const TABLE_WAIT_TIME = 12000
export default {
    data () {
        return {
            eventListeners: [],
            isWorking: false,
            workingItemUid: null
        }
    },
    watch: {
        eventListeners (newV) {
            if (newV && newV.length && !this.isWorking) {
                this.isWorking = true
            }
        },
        isWorking (newV) {
            if (newV) {
                if (!this.eventListeners.length) {
                    this.isWorking = false
                    return
                }
                const item = this.eventListeners.shift()
                this.workingItemUid = item.uid
                const event = new CustomEvent('startTableColumnsWidthAutoAdjust', {
                    detail: {
                        uid: item.uid
                    }
                })
                document.dispatchEvent(event)
                const uid = item.uid
                const _this = this
                let longTableCalculations = setTimeout(function() {
                    if (_this.workingItemUid === uid) {
                        _this.workingItemUid = null
                        _this.isWorking = false
                    }
                    clearTimeout(longTableCalculations)
                }, TABLE_WAIT_TIME)
            } else if (!newV && this.eventListeners.length) {
                this.isWorking = true
            }
        }
    },
    created() {
        const _this = this
        document.addEventListener('registerTableColumnsWidthAutoAdjust', function (e) {
            if (!_this.eventListeners.find(el => el.uid === e.detail.uid)) {
                _this.eventListeners.push({
                    uid: e.detail.uid
                })
            }
        })
        document.addEventListener('endTableColumnsWidthAutoAdjust', function (e) {
            if (!_this.eventListeners.find(el => el.uid === e.detail.uid)) {
                _this.workingItemUid = null
                _this.isWorking = false
            }
        })
    }
}